import Bloc from './Bloc.js';
import Types from './Types.js';

export default class CompareLocations extends Bloc {

	constructor (src, ctx) {

		super("cmplocations", src, ctx);
		this.f = (src, ins, props) => {
			if (!ins[0] || !ins[1])
				return [false];
			return [ins[0].type === ins[1].type];
		}
		this.types = [Types.location, Types.location];
	}
}